import React, { Component } from 'react';
import { TableStatus } from '../../Enum/TableStatus';
import { withRouter } from 'react-router-dom';
import TableSessionHelper from '../../../../Model/TableSession';

class TableActionButtons extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }
    getTableActionButton(table, status) {
        const labelText = lang.order
        let btnClass = " btn-default" + (this.props.direction == 'vertical' ? '' : " pull-right")
        return <button id={`order-btn-${this.props.index}`} className={"mr-1 btn " + btnClass} style={{minWidth:"70px"}} disabled={status == TableStatus.BILLING} onClick={() => {
            this.props.history.push(`table/${table.id}/category`)
        }}>{labelText}</button>
    }
    // getTableStatusLabel(table) {
    //     const status = this.props.parent.getTableStatus(table)
    //     let labelText = lang.open
    //     let className = "label-table-status" + (this.props.direction == 'vertical' ? '' : ' pull-right')
    //     let activeSessionCount = TableSessionHelper.getSessionsForTableWithActiveOrders(table).length
    //     console.log(123)
    //     if (table.name == '17') {
    //         console.log(123)
    //     }
    //     switch (status) {
    //         case TableStatus.OPEN:
    //             className += " text-success"
    //             labelText = lang.open
    //             break
    //         case TableStatus.SITTING && activeSessionCount > 0:
    //             className += " text-warning"
    //             labelText = lang.sitting
    //             break
    //         case TableStatus.BILLING:
    //             className += " text-danger"
    //             labelText = lang.billing
    //             break
    //     }

    //     return <span className={className}>{labelText}</span>
    // }
    renderVerticalButtons = (table, status) => {
        return (
            <React.Fragment>
                <span style={{textAlign:this.props.textAlign, backgroundColor:"green"}}>
                    <h4><b>{`${lang.table} ${table.name}`}</b></h4>
                    <div className="clearfix">{this.getTableStatusLabel(table)}</div>
                    <div>
                        <div className="btn-group">
                            <button type="button" className="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {lang.action} <span className="caret"></span>
                            </button>
                            <ul className="dropdown-menu dropdown-menu-right">
                                <li className={status == 0 ? "disabled" : ""}><a onClick={() => {this.props.parent.showPIN(table)}}>{lang.show_pin}</a></li>
                                <li role="separator" className="divider"></li>
                                <li><a onClick={() => {this.showQR(table.id)}}>{lang.qr_code}</a></li>
                                <li role="separator" className="divider"></li>
                                <li className={status == 0 ? "disabled" : ""}><a onClick={() => {
                                    if (status != 0) {
                                        this.props.parent.onChangeTable(table)
                                    }
                                }}>{lang.change_table}</a></li>
                                <li role="separator" className="divider"></li>
                                <li className={status == 0 ? "disabled" : ""}><a onClick={() => {
                                    if (status != 0) {
                                        this.onClearTable(table)
                                    }
                                }}>{lang.clear_table}</a></li>
                            </ul>
                        </div>
                    </div>
                    <div>
                        <button className={"btn" + (status != 0 ? " btn-primary" : " disabled btn-default")} style={{minWidth:"70px"}} onClick={() => {
                                if (status != 0) {
                                    this.props.parent.onBill(table)
                                }
                            }}>{lang.bill}
                        </button>
                    </div>
                    {
                        this.props.parent.getTableActionButton(table, status, true)
                            .map(button => <div>{button}</div>)
                    }
                </span>
            </React.Fragment>
        )
    }
    getTableStatusLabel = (table) => {
        let status = this.props.parent.getTableStatus(table)
        let activeSessionCount = TableSessionHelper.getSessionsForTableWithActiveOrders(table).length
        let labelText = lang.open
        let className = "pull-right label-table-status"
        let tableStatusColorClass = " text-success"
        status = TableStatus.SITTING && activeSessionCount ? "sitting" : status
        switch (status) {
            case TableStatus.SITTING:
                tableStatusColorClass = " text-warning"
                labelText = lang.sitting
                break
            case TableStatus.OPEN:
                tableStatusColorClass = " text-success"
                labelText = lang.open
                break
            case "sitting":
                tableStatusColorClass = " text-warning"
                labelText = lang.sitting
                break
            case TableStatus.BILLING:
                tableStatusColorClass = " text-danger"
                labelText = lang.billing
                break
        }
        className += tableStatusColorClass
        return <span className={className}>{labelText}</span>
    }
    getTableActionButton = (table, status) => {
        const labelText = lang.order
        let activeSessionCount = this.props.app.state.sessions.filter(session => session.table_id == table.id && !session.bill_id).length
        let billingSessionCount = this.props.app.state.sessions.filter(session => session.table_id == table.id && session.bill_id).length

        const btnClass = " btn-default"
        return <span style={{position:"relative"}} className="mr-1 pull-right">
            <button className={status == 0 ? "disabled btn" + btnClass : "btn " + btnClass} onClick={() => {
                            if (status != 0) {this.onClearTable(table)}
                        }} style={{minWidth:"70px", marginRight:"5px"}}>{lang.clear_table}</button>
            <button id={`order-btn-${this.props.index}`} className={"btn " + btnClass} style={{minWidth:"70px"}} data-id={table.id} onClick={this.btnOrderClicked}>{labelText}</button>
            <span style={{position:"absolute", top:"-12px", right:"-5px"}}>
                {billingSessionCount > 0 && <span className="label label-warning">{billingSessionCount}</span>}
                {activeSessionCount > 0 && <span className="label label-success">{activeSessionCount}</span>}
            </span>
        </span>
    }
    getActionDropdownButton = () => {
        return <div className="btn-group pull-right" style={{ marginLeft: "6px" }}>
            <button type="button" className="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {lang.action} <span className="caret"></span>
            </button>
            <ul className="dropdown-menu">
                <li className="disabled"><a href="#">{lang.add_order}</a></li>
                <li role="separator" className="divider"></li>
                <li className={status == 0 ? "disabled" : ""}><a onClick={() => {this.showPIN(table)}}>{lang.show_pin}</a></li>
                <li role="separator" className="divider"></li>
                <li><a onClick={() => {this.showQR(table.id)}}>{lang.qr_code}</a></li>
                <li role="separator" className="divider"></li>
                <li className={status == 0 ? "disabled" : ""}><a onClick={() => {
                    if (status != 0) {
                        this.onChangeTable(table)
                    }
                }}>{lang.change_table}</a></li>
                <li role="separator" className="divider"></li>
                <li className={status == 0 ? "disabled" : ""}><a onClick={() => {
                    if (status != 0) {
                        this.onClearTable(table)
                    }
                }}>{lang.clear_table}</a></li>
            </ul>
        </div>
    }
    getBillButton = (status) => {
        return <button className={"btn pull-right" + (status != 0 ? " btn-primary" : " disabled btn-default")} style={{minWidth:"70px"}} onClick={() => {
            if (status != 0) {
                this.onBill(table)
            }
        }}>{lang.bill}</button>
    }
    render() {
        const table = this.props.table
        const status = this.props.parent.getTableStatus(table)
        const isVertical = this.props.direction == "vertical";
        const marginClass = isVertical ? "mt-2" : "ml-1"

        const firstLayerButtons = <SingleLayer
            table={table}
            isVertical={isVertical}
            getTableStatusLabel={this.props.getTableStatusLabel || this.getTableStatusLabel}
            tableActionButtons={this.props.parent.getTableActionButton(table, status, true, this.props.index)}
            trailing={this.props.trailing || []}
        />

        let isArrived = null
        if (this.props.showCustomerArrived) {

        }

        const renderResult = (
            <React.Fragment>
                {
                    true ?
                    <div className="pos-table-listing-item-buttons-layers" style={{display: "flex", flexDirection: "column"}}>
                        <div style={{flex: "1 0 50px"}}>{firstLayerButtons}</div>
                        <IsArrived table={table} />
                        <IsCashOnDelivery table={table} />
                    </div> :
                    firstLayerButtons
                }
            </React.Fragment>
        )
        return renderResult
    }
}

function IsCashOnDelivery({table}) {
    let isCashOnDelivery = false
    if (table.table_session_id) {
        let tableSession = TableSessionHelper.find(table.table_session_id)
        isCashOnDelivery = tableSession && tableSession.is_cash_on_delivery
    }
    if (isCashOnDelivery) {
        return <div style={{flex: "3 0 50px", fontWeight:"bold", fontSize: "14pt"}} className="text-success">
            <span>{lang.payment_method_cod}</span>
        </div>
    }
    return null
}
function IsArrived({table}) {
    let isArrived = false
    if (table.table_session_id) {
        let tableSession = TableSessionHelper.find(table.table_session_id)
        isArrived = tableSession && tableSession.customer_arrived_at
    }
    if (isArrived) {
        return <div style={{flex: "3 0 50px", textAlign:"right", fontWeight:"bold", fontSize: "14pt"}} className="text-success">
            <span className="blink_me">{lang.customer_arrived}</span>
        </div>
    }
    return null
}

function SingleLayer({isVertical, getTableStatusLabel, tableActionButtons, table, trailing}) {
    const marginClass = isVertical ? "mt-2" : "ml-1"
    return <div style={{display:"flex", alignItems: isVertical ? "flex-start" :  "stretch", flexDirection: isVertical ? "column" : "row", textAlign:""}}>
        { isVertical && <h4><b>{`${lang.table} ${table.name}`}</b></h4>}
        { getTableStatusLabel(table) }
        {
            (tableActionButtons || [])
            .map((button, index) => <div key={index} className={marginClass}>{button}</div>)
        }
        {
            (trailing || [])
            .map((button, index) => <div key={index} className={marginClass}>{button}</div>)
        }
    </div>
}

export default withRouter(TableActionButtons);